import {Component, Input, OnInit} from '@angular/core';
import {PedidosService} from "../../services/pedidos.service";

@Component({
  selector: 'app-razao-cancelamento-99food',
  templateUrl: './razao-cancelamento-99food.component.html',
  styleUrls: ['./razao-cancelamento-99food.component.scss']
})
export class RazaoCancelamento99foodComponent implements OnInit {
  @Input() pedido: any;
  razaoCancelamento: any;
  razoesCancelamento  = [];
  erroParaCancelar: string;
  constructor(protected pedidosService: PedidosService) { }

  ngOnInit(): void {  }

  obtenhaRazoesCancamento(){
    if(!this.pedido || this.razoesCancelamento.length) return this.razoesCancelamento;

    if(!this.erroParaCancelar){
      this.pedidosService.obtenhaRazoesCancelamento99Food(this.pedido).then((razoes: any) => {
        this.razoesCancelamento = razoes;
        if(!razoes.length)
          this.erroParaCancelar = 'Pedido não pode ser mais cancelado no 99food'

      }).catch((erro) => {
        this.erroParaCancelar = erro;
      })
    }
  }
}
